/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Drew Burnett
 */

// Imports

import { Button, Label, trackEvent, VideoControlButton } from "trux"
import { createQuickSaveForwardingUrl } from "../util/quickSave"
import { getGameTime } from "../util/gameTime"
import React from "react"

// Save Button

const SaveButton = ({
    game,
    event,
    saveUrl,
    history,
    location,
    trkAction,
    createUrl,
    buttonRef,
    afterOnClick,
    insideMoment,
}) => {
    const handleOnClick = (e) => {
        let gameTime = 0
        if (event) {
            gameTime = getGameTime(game)
        }
        // Let's track the event in Matomo
        trackEvent({
            context: "Save Button",
            action: "Save Pressed",
            element: e.currentTarget,
        })
        // TODO: missing inside moment?
        const forwardingUrl = createQuickSaveForwardingUrl(
            gameTime,
            location,
            createUrl,
            saveUrl,
            insideMoment
        )
        history.push(forwardingUrl)
        // If the afterOnClick prop is supplied & is a function, let's call it
        if (typeof afterOnClick === "function") {
            afterOnClick(e)
        }
    }

    const videoControlButtonTitle = !insideMoment
        ? "Create and save a highlight"
        : "Save highlight to Trace iD"
    const videoControlButtonCn = !insideMoment
        ? "SaveVideoControlButton create"
        : "SaveVideoControlButton save"

    return (
        <VideoControlButton
            className={videoControlButtonCn}
            title={videoControlButtonTitle}
        >
            <Button
                ref={buttonRef}
                small
                trkAction={trkAction}
                width="100%"
                className="SaveButton"
                primary
                content={<Label>Save</Label>}
                onClick={(e) => {
                    handleOnClick(e)
                }}
            />
        </VideoControlButton>
    )
}

export { SaveButton }
